// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2xzd9","row":"Node_row__2LGNT","label":"Node_label__1-VRf","footer":"Node_footer__l6Dd2"};